// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/svg/BellLineBackgroundIcon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RightContainer_rightContainer__Z4H6c {
  align-items: baseline;
  display: flex;
  flex-direction: column;
  width: 29%;
  min-width: 340px;
}
.RightContainer_calendar__7t4GF {
  color: #5f6d7e;
  font-weight: 600;
  width: 100%;
}
.RightContainer_calendarWrapper__VyhNj {
  box-shadow: 4px 4px 64px 10px #5f6d7e1a;
  border: 1px solid #d9dce0;
  border-radius: 10px;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
}
.RightContainer_calendarBtn__7Qsve,
.RightContainer_calendarWrapper__VyhNj {
  display: flex;
  align-items: center;
  justify-content: center;
}
.RightContainer_calendarBtn__7Qsve {
  margin-top: -40px;
  margin-bottom: 24px;
  width: 80%;
  gap: 10px;
  background-color: #cb9c2d;
  border: none;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  height: 52px;
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  color: #ffffff;
  z-index: 100;
}
.RightContainer_calendarBtn__7Qsve:hover {
  cursor: pointer;
  background-color: #a78025;
}
.RightContainer_roomsUsageContainer__KwCYH {
  background: top right url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat;
  border: 2px solid #d9dce0;
  border-radius: 10px;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: 40px 24px 24px;
  transition: border 200ms ease-in-out;
  width: -webkit-fill-available;
  margin-top: 48px;
  box-sizing: border-box;
  width: 100%;
}

.RightContainer_rooms__r7ZCd {
  width: 100%;
}

.RightContainer_roomsUsageContainer__KwCYH:hover {
  border: 2px solid #5f6d7e;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  transition: border 200ms ease-in-out;
}

.RightContainer_roomsUsageIcon__0WeGK {
  stroke: #5f6d7e;
}
.RightContainer_roomsUsageDivider__yRn3S {
  border-top: 2px solid #5f6d7e;
  margin: 16px 0px 32px;
  width: 40px;
}
.RightContainer_roomsUsageTextContainer__xuizA {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.RightContainer_roomsUsageText__Mn7FP,
.RightContainer_upcomingTitle__BjUJX {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.001em;
}
.RightContainer_roomsUsageText__Mn7FP {
  color: #5f6d7e;
  margin: 0px;
  text-transform: uppercase;
}
.RightContainer_upcomingEventsContainer__sAFxM {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  gap: 16px;
  width: 100%;
}
.RightContainer_upcomingTitle__BjUJX {
  text-align: left;
  color: #4d4d4d;
}
@media screen and (max-width: 400px) {
  .RightContainer_rightContainer__Z4H6c {
    width: 100%;
  }
  .RightContainer_calendarWrapper__VyhNj {
    padding-left: 10px;
  }
}

@media screen and (max-width: 370px) {
  .RightContainer_upcomingEventsContainer__sAFxM {
    width: 89%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/dashboard/components/RightContainer/RightContainer.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE;aACW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,oDAAoD;EACpD,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".rightContainer {\n  align-items: baseline;\n  display: flex;\n  flex-direction: column;\n  width: 29%;\n  min-width: 340px;\n}\n.calendar {\n  color: #5f6d7e;\n  font-weight: 600;\n  width: 100%;\n}\n.calendarWrapper {\n  box-shadow: 4px 4px 64px 10px #5f6d7e1a;\n  border: 1px solid #d9dce0;\n  border-radius: 10px;\n  align-items: flex-start;\n  flex-direction: column;\n  box-sizing: border-box;\n  width: 100%;\n}\n.calendarBtn,\n.calendarWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.calendarBtn {\n  margin-top: -40px;\n  margin-bottom: 24px;\n  width: 80%;\n  gap: 10px;\n  background-color: #cb9c2d;\n  border: none;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  height: 52px;\n  font-family: Inter;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  color: #ffffff;\n  z-index: 100;\n}\n.calendarBtn:hover {\n  cursor: pointer;\n  background-color: #a78025;\n}\n.roomsUsageContainer {\n  background: top right url(\"../../../../assets/svg/BellLineBackgroundIcon.svg\")\n    no-repeat;\n  border: 2px solid #d9dce0;\n  border-radius: 10px;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  padding: 40px 24px 24px;\n  transition: border 200ms ease-in-out;\n  width: -webkit-fill-available;\n  margin-top: 48px;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.rooms {\n  width: 100%;\n}\n\n.roomsUsageContainer:hover {\n  border: 2px solid #5f6d7e;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  transition: border 200ms ease-in-out;\n}\n\n.roomsUsageIcon {\n  stroke: #5f6d7e;\n}\n.roomsUsageDivider {\n  border-top: 2px solid #5f6d7e;\n  margin: 16px 0px 32px;\n  width: 40px;\n}\n.roomsUsageTextContainer {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n.roomsUsageText,\n.upcomingTitle {\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n}\n.roomsUsageText {\n  color: #5f6d7e;\n  margin: 0px;\n  text-transform: uppercase;\n}\n.upcomingEventsContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  gap: 16px;\n  width: 100%;\n}\n.upcomingTitle {\n  text-align: left;\n  color: #4d4d4d;\n}\n@media screen and (max-width: 400px) {\n  .rightContainer {\n    width: 100%;\n  }\n  .calendarWrapper {\n    padding-left: 10px;\n  }\n}\n\n@media screen and (max-width: 370px) {\n  .upcomingEventsContainer {\n    width: 89%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightContainer": `RightContainer_rightContainer__Z4H6c`,
	"calendar": `RightContainer_calendar__7t4GF`,
	"calendarWrapper": `RightContainer_calendarWrapper__VyhNj`,
	"calendarBtn": `RightContainer_calendarBtn__7Qsve`,
	"roomsUsageContainer": `RightContainer_roomsUsageContainer__KwCYH`,
	"rooms": `RightContainer_rooms__r7ZCd`,
	"roomsUsageIcon": `RightContainer_roomsUsageIcon__0WeGK`,
	"roomsUsageDivider": `RightContainer_roomsUsageDivider__yRn3S`,
	"roomsUsageTextContainer": `RightContainer_roomsUsageTextContainer__xuizA`,
	"roomsUsageText": `RightContainer_roomsUsageText__Mn7FP`,
	"upcomingTitle": `RightContainer_upcomingTitle__BjUJX`,
	"upcomingEventsContainer": `RightContainer_upcomingEventsContainer__sAFxM`
};
export default ___CSS_LOADER_EXPORT___;
